import { render, staticRenderFns } from "./AllUsersView.vue?vue&type=template&id=4b45231e&scoped=true&"
import script from "./AllUsersView.vue?vue&type=script&lang=js&"
export * from "./AllUsersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b45231e",
  null
  
)

export default component.exports